import classNames from 'classnames';
import type { FC } from 'react';
import { Spinner } from 'ui-library/components/Spinner/Spinner';
import s from './DotLoader.module.scss';

export const DotLoader: FC<{ fullScreen?: boolean }> = ({ fullScreen }) => {
  'use memo';

  return (
    <div className={classNames(s.dotLoader, { [s.fullScreen]: fullScreen })}>
      <Spinner variant="dots" size={35} />
    </div>
  );
};
